import React from 'react';
import { Layout } from '../../Layout';
import { useUserNoAccessStyles } from './UserNoAccess.styles';
import { Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const UserNoAccess: React.FC = () => {
  const { classes } = useUserNoAccessStyles();
  return (
    <Layout>
      <div className={classes.root}>
        <div className={classes.content}>
          <div>
            <LockOutlinedIcon className={classes.lockIcon} />
          </div>
          <Typography className={classes.noAccess}>No Access</Typography>
          <p className={classes.errorText}>
            User does not exist in the system or does not have permission to
            access the application. Please contact administrator.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default UserNoAccess;
